import React from 'react';
import { Calendar, Clock, ArrowLeft, ExternalLink } from 'lucide-react';
import { BLOG_POSTS } from '../data/config';

const Posts = ({ onBack }) => {
  return (
    <div className="min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <button
          onClick={onBack}
          className="mb-8 flex items-center gap-2 text-cream-200 hover:text-cream-100 transition-colors group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          <span className="font-semibold">Back to Home</span>
        </button>

        {/* Header */}
        <div className="mb-12">
          <h1 
            className="text-5xl md:text-6xl font-bold mb-4"
            style={{
              fontFamily: 'Righteous, sans-serif',
              background: 'linear-gradient(135deg, #f5e6d3 0%, #e8d4bf 25%, #d9c3ab 50%, #cab297 75%, #bba183 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Blog Posts
          </h1>
          <p className="text-lg text-cream-200">
            Thoughts on development, automation, and building cool stuff.
          </p>
        </div>

        {/* Posts Grid */}
        <div className="space-y-6">
          {BLOG_POSTS.map((post) => (
            <article
              key={post.id}
              className="glass-card p-6 hover:bg-glass-light transition-all duration-300 group"
            >
              <div className="flex flex-col gap-4">
                {/* Post Header */}
                <div className="flex items-start justify-between gap-4">
                  <h2 className="text-2xl font-bold text-cream-100 group-hover:text-cream-50 transition-colors">
                    {post.title}
                  </h2>
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-shrink-0 p-2 rounded-lg hover:bg-glass-light transition-all"
                    aria-label="Read post"
                  >
                    <ExternalLink className="w-5 h-5 text-cream-200" />
                  </a>
                </div>

                {/* Post Meta */}
                <div className="flex flex-wrap items-center gap-4 text-sm text-cream-300">
                  <div className="flex items-center gap-1.5">
                    <Calendar className="w-4 h-4" />
                    <span>{new Date(post.date).toLocaleDateString('en-US', { 
                      month: 'long', 
                      day: 'numeric', 
                      year: 'numeric' 
                    })}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <Clock className="w-4 h-4" />
                    <span>{post.readTime} read</span>
                  </div>
                </div>

                {/* Post Excerpt */}
                <p className="text-cream-200 leading-relaxed">
                  {post.excerpt}
                </p>

                {/* Read More Button */}
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-cream-100 font-semibold hover:gap-3 transition-all"
                >
                  <span>Read full article</span>
                  <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* Empty State */}
        {BLOG_POSTS.length === 0 && (
          <div className="glass-card p-12 text-center">
            <div className="text-6xl mb-4">📝</div>
            <h3 className="text-2xl font-bold text-cream-100 mb-2">No posts yet</h3>
            <p className="text-cream-200">
              Check back soon for new content!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Posts;
